import get from 'lodash/fp/get';
import { createSelector } from 'reselect';
import { isInProduct } from 'utils/inProduct';

const getIsInProductMagazine = createSelector(
  get('router'),
  ({ location }) => isInProduct(location),
);

export default getIsInProductMagazine;
